<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-address-book"></i> Contato Interno</h3>
      </div>
    </div>
    <ContactInternalAdd v-if="showAdd" ref="ContactInternalAdd" v-on:Back="onBack" />
    <ContactInternalList v-else ref="ContactInternalList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import ContactInternalAdd from './components/add/ciadd.vue'
import ContactInternalList from './components/list/cilist.vue'

export default {
  name: 'ContactInternal',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    ContactInternalAdd,
    ContactInternalList
  },
  mounted () {
    // Tools.MinimizedSidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.ContactInternalAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
      // this.$refs.ContactInternalList.onLoad()
    }
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/contacts/internal/contactinternal.vue